import React, {useCallback, useContext, useEffect, useState} from 'react';
import {
	AccordionActions,
	AccordionDetails, Backdrop,
	Button,
	CircularProgress,
	Divider, List, ListItem, ListItemText,
	MenuItem, TextField,
	Tooltip,
	Typography
} from "@mui/material";
import Grid from "@mui/material/Grid";
import CustomSelect from "../../../../widgets/inputs/CustomSelect";
import {BaseStyle} from "../../../../../styles/shared/BaseStyle";
import {useFormContext} from "react-hook-form";
import {sintomi, tipologieQuarantena, tipoMonitortaggio} from "../../../../../utils/arrays/Generics";
import {RadioGroupQuestion} from "../../../../widgets/inputs/RadioGroupQuestion";
import {bigNoteRegisterNotRequired} from "../../../../../utils/RegisterUtils";
import CustomMultiText from "../../../../widgets/inputs/CustomMultiText";
import CustomDateInput from "../../../../widgets/inputs/CustomDateInput";
import {addDays, diffDays, removeDays} from "../../../../../utils/GenericUtils";
import {generateQuarantenaV2, resetAddQuarantena} from "../../../../../services/QuaranteneServices";
import {useParams} from "react-router-dom";
import {IntervistaContext, QuarantenaContext, TamponiContext} from "../IntervistaOld";
import {setOpenSnackbar} from "../../../../../services/AppServices";
import {AnagraficaContext, AppContext} from "../../../../../App";
import AddTwoToneIcon from '@mui/icons-material/AddTwoTone';
import RemoveTwoToneIcon from '@mui/icons-material/RemoveTwoTone';
import IconButton from "@mui/material/IconButton";
import {useTheme} from "@mui/styles";
import moment from "moment";
import {prenotaTampone} from "../../../../../services/TamponiServices";
import { Alert, AlertTitle, Autocomplete } from '@mui/material';
import GoogleMaps from "../../../../widgets/inputs/GoogleMapsInput";
import {getListaOf, getTagListaOf} from "../../../../../services/utils/IntervistaApiData";
import {getDiario} from "../../../../../services/AnagraficaServices";
import {PaperComponent} from "../../../../../styles/components/DynamicComponentStyle";

const QuarantenaStep = ({tipoPaziente, setStep}) => {
	const classes = BaseStyle();
	const {errors, control, handleSubmit, register, watch, setValue, getValues, clearErrors} = useFormContext();
	const intervistaContext = useContext(IntervistaContext);
	const appContext = useContext(AppContext);
	const anagraficaContext = useContext(AnagraficaContext);
	const quarantenaContext = useContext(QuarantenaContext);
	const tamponiContext = useContext(TamponiContext);
	let {idSoggetto, idFocolaio} = useParams();
	const [submit, setSubmit] = useState(false);
	const [submitPrenotaTampone, setSubmitPrenotaTampone] = useState(false);
	const [tipo, setTipo] = useState("");
	let theme = useTheme();
	const [value1, setValue1] = useState(null);
	const [inputValue1, setInputValue1] = useState("");
	const [tags, setTags] = useState([]);

	const handleCreateTag = event => {
		switch (event.key) {
			case ",":
			case "\n":
			case "\t":
			case " ": {
				event.preventDefault();
				event.stopPropagation();
				if (event.target.value.length > 0) {
					setTags([...tags, "#" + event.target.value?.toUpperCase()]);
				}
				break;
			}
			default:
		}
	};

	const getTipoPaziente = useCallback((tipoPaziente) => {
		switch (tipoPaziente) {
			default:
				return tipoPaziente;
			case "pazientezero.":
				return "PAZ_ZERO";
			case "contattistretti.":
				return "CON_NCOV";
			case "contatticonviventi.":
				return "CON_COV";
		}
	}, [])

	const goForward = useCallback((data) => {
		console.log(errors);
		if (data.quarantena?.["indirizzoId"]) {
			setTipo(data["quarantena"]?.["tipo"])
			setSubmit(true);
			let intermediateScore = getListaOf(sintomi, intervistaContext.state.intervista).split(",");
			let dataInizio = data["quarantena"]?.["dataInizio"]
			dataInizio?.setHours(0);
			dataInizio?.setMinutes(0);
			dataInizio?.setSeconds(0);
			dataInizio?.setMilliseconds(0);
			let dataFine = data["quarantena"]?.["dataFine"]
			dataFine?.setHours(0);
			dataFine?.setMinutes(0);
			dataFine?.setSeconds(0);
			dataFine?.setMilliseconds(0);
			if (dataInizio.getTime() === dataFine.getTime()) {
				setOpenSnackbar("warning", "Attenzione: le due date non possono coincidere!", appContext.dispatch);
			} else {
				generateQuarantenaV2({
					...data["quarantena"],
					dataInizio: dataInizio,
					dataFine: dataFine,
					note: tags.join(" ") + (tags.length > 0 ? " " : "") + getTagListaOf(sintomi, intervistaContext.state.intervista) + " " + data?.quarantenaNote,
					idIntervista: intervistaContext.state.intervista.id,
					score: Math.round(intermediateScore.length * 4 / 11),
					soggetto: {
						idSoggetto: (tipoPaziente === "pazientezero." && idSoggetto !== "NULL") ? idSoggetto : anagraficaContext.state.anagrafica?.idSoggetto,
					},
					tipoPaziente: getTipoPaziente(tipoPaziente),
					idFocolaio: quarantenaContext.state.idFocolaio ? quarantenaContext.state.idFocolaio : idFocolaio,
				}, quarantenaContext.dispatch, tipoPaziente === "pazientezero.", (idFocolaio ? idFocolaio : quarantenaContext.state.idFocolaio), getTipoPaziente(tipoPaziente));
			}
		} else {
			setOpenSnackbar("warning", "Attenzione! Controlla bene l'indirizzo associato alla quarantena in quanto è possibile che non sia stato inserito correttamente.", appContext.dispatch);
		}
	}, [quarantenaContext.dispatch, tipoPaziente, intervistaContext.state.intervista, idSoggetto, getTipoPaziente,
		anagraficaContext.state.anagrafica, quarantenaContext.state.idFocolaio, idFocolaio, tags, appContext.dispatch, errors])

	const onPrenotaTampone = useCallback(() => {
		let data = getValues()?.["tampone"];
		if (data && data["dataRichiesta"]) {
			setSubmitPrenotaTampone(true);
			prenotaTampone({
				...data,
				codF: tamponiContext.state.tampone.codF,
				soggetto: anagraficaContext.state.anagrafica
			}, tamponiContext.dispatch);
		} else {
			setOpenSnackbar("error", "Controlla bene di aver inserito una data per il tampone!", appContext.dispatch)
		}
	}, [tamponiContext.dispatch, getValues, appContext.dispatch, tamponiContext.state.tampone, anagraficaContext.state.anagrafica])

	useEffect(() => {
		if (submitPrenotaTampone && !tamponiContext.state.loadingPrenotaTampone && tamponiContext.state.errorPrenotaTampone === "") {
			setSubmitPrenotaTampone(false);
			setOpenSnackbar("success", "Richiesta eseguita con successo! L' ufficio tamponi la prenderà in carico quanto prima", appContext.dispatch);
		} else if (submitPrenotaTampone && !tamponiContext.state.loadingPrenotaTampone && tamponiContext.state.errorPrenotaTampone !== "") {
			setSubmitPrenotaTampone(false);
			setOpenSnackbar("error", tamponiContext.state.errorPrenotaTampone, appContext.dispatch);
		}
	}, [submitPrenotaTampone, tamponiContext.state.loadingPrenotaTampone, tamponiContext.state.errorPrenotaTampone,
		appContext.dispatch])

	useEffect(() => {
		if (submit && !quarantenaContext.state.loadingGenerateQuarantena && quarantenaContext.state.errorGenerateQuarantena === "") {
			if (quarantenaContext.state.quarantena?.errors) {
				setOpenSnackbar("info", quarantenaContext.state.quarantena.errors, appContext.dispatch);
			} else {
				setOpenSnackbar("success", tipo + " creato correttamente", appContext.dispatch);
			}
			getDiario((tipoPaziente === "pazientezero." && idSoggetto !== "NULL") ? idSoggetto : anagraficaContext.state.anagrafica?.idSoggetto, anagraficaContext.dispatch)
			resetAddQuarantena(quarantenaContext.dispatch);
			setSubmit(false);
			setStep(prevState => ++prevState);
		} else if (submit && !quarantenaContext.state.loadingGenerateQuarantena && quarantenaContext.state.errorGenerateQuarantena !== "") {
			setOpenSnackbar("error", tipo + " non creato. Riprova tra qualche minuto", appContext.dispatch);
			setSubmit(false);
		}
	}, [quarantenaContext.state.loadingGenerateQuarantena, quarantenaContext.state.errorGenerateQuarantena, setStep,
		appContext.dispatch, tipo, submit, quarantenaContext.dispatch, quarantenaContext.state.quarantena, idSoggetto, anagraficaContext.dispatch, tipoPaziente, anagraficaContext.state.anagrafica])

	useEffect(() => {
		register("quarantena.indirizzo", {required: true});
		register("quarantena.indirizzoId");
	}, [register])

	useEffect(() => {
		if (value1 !== null) {
			setValue("quarantena.indirizzo", inputValue1)
			setValue("quarantena.indirizzoId", value1.place_id)
		}
	}, [value1, inputValue1, setValue])

	useEffect(() => {
		clearErrors();
	}, [tipoPaziente, clearErrors])

	return (
        <React.Fragment>
            <Backdrop open={submit} className={classes.backdrop}>
				<CircularProgress/>
			</Backdrop>
            <AccordionDetails>
				<Grid container spacing={3}>
					<Grid item xs={12} sm={6}>
						<CustomSelect
							label={"Quarantena o isolamento?"}
							control={control}
							defaultValue={tipoPaziente === "pazientezero." ? tipologieQuarantena[0] : ""}
							autoFocus={true}
							rules={{required: true}}
							name={"quarantena.tipo"}
							error={errors["quarantena"]?.["tipo"]}
						>
							{tipologieQuarantena.map((val, key) => {
								return (
									<MenuItem value={val} key={key}>
										{val}
									</MenuItem>
								);
							})}
						</CustomSelect>
					</Grid>
					<Grid item xs={12} sm={6}>
						<CustomSelect
							label={"Tipo di monitoraggio"}
							control={control}
							defaultValue={tipoMonitortaggio[0]}
							autoFocus={false}
							rules={{required: true}}
							name={"quarantena.tipoMonitoraggio"}
							error={errors["quarantena"]?.["tipoMonitoraggio"]}
						>
							{tipoMonitortaggio.map((val, key) => {
								return (
									<MenuItem value={val} key={key}>
										{val}
									</MenuItem>
								);
							})}
						</CustomSelect>
					</Grid>
					<Grid item xs={12}>
						<RadioGroupQuestion
							question={"Vuoi protocollare questo/a Isolamento/Quarantena?"}
							control={control}
							defaultValue={"true"}
							rules={{required: true}}
							name={"quarantena.protocollo"}
							error={errors["quarantena"]?.["protocollo"]}
						/>
					</Grid>
					<Grid item xs={12}>
						<Alert severity="info" style={{borderRadius: 24, margin: 4}}>
							<AlertTitle><b>Info</b></AlertTitle>
							Il paziente ha indicato i seguenti indirizzi all'interno dell'intervista, copia quello di tuo
							interesse cliccandoci sopra ed incollalo poi nel campo "Indirizzo associato alla quarantena *". Se non
							sono presenti indirizzi non ti preoccupare, chiedi al paziente dove effettuerà la
							quarantena/isolamento: potrai sempre modificare l'anagrafica di un paziente in un secondo momento<br/>
							<List>
								{
									watch("indirizzoDomicilio") && <ListItem
										button
										onClick={() => {
											navigator?.clipboard?.writeText(watch("indirizzoDomicilio"))
											setOpenSnackbar("info", "Indirizzo copiato negli appunti", appContext.dispatch)
										}}
										style={{borderRadius: 24}}>
										<ListItemText>Domicilio: {watch("indirizzoDomicilio")}</ListItemText>
									</ListItem>}
								{
									watch("indirizzoResidenza") && <ListItem
										button
										onClick={() => {
											navigator?.clipboard?.writeText(watch("indirizzoResidenza"))
											setOpenSnackbar("info", "Indirizzo copiato negli appunti", appContext.dispatch)
										}}
										style={{borderRadius: 24}}>
										<ListItemText>Residenza: {watch("indirizzoResidenza")}</ListItemText>
									</ListItem>}
								{
									watch("indirizzoAzienda") &&
									<ListItem
										button
										onClick={() => {
											navigator?.clipboard?.writeText(watch("indirizzoAzienda"))
											setOpenSnackbar("info", "Indirizzo copiato negli appunti", appContext.dispatch)
										}}
										style={{borderRadius: 24}}>
										<ListItemText>Azienda: {watch("indirizzoAzienda")}</ListItemText>
									</ListItem>
								}
							</List>
						</Alert>
					</Grid>
					<Grid item xs={12}>
						<GoogleMaps value={value1} setValue={setValue1} inputValue={inputValue1}
						            setInputValue={setInputValue1}
						            label={"Indirizzo associato all'ordinanza *"}/>
					</Grid>
					<Grid item xs={12}>
						<CustomMultiText
							inputRef={register(bigNoteRegisterNotRequired)}
							label={"Note aggiuntive"}
							autofocus={false}
							name={"quarantenaNote"}
							error={errors["quarantenaNote"]}
						/>
					</Grid>
					{/*//TAG*/}
					<Grid item xs={12}>
						<Autocomplete
							multiple
							freeSolo
							options={[]}
							PaperComponent={PaperComponent}
							getOptionLabel={option => option || option}
							value={tags}
							onChange={(event, newValue) => setTags(newValue)}
							filterSelectedOptions
							renderInput={params => {
								params.inputProps.onKeyDown = handleCreateTag;
								return (
									<TextField
										{...params}
										variant="outlined"
										label="TAG da assegnare alla quarantena"
										fullWidth
									/>
								);
							}}
						/>
					</Grid>
					{/*//TAG*/}
					<Grid item xs={12}>

						{/*INFO DA MOSTRARE A TUTTI*/}
						<Alert severity="info" style={{borderRadius: 24, margin: 4}}>
							<AlertTitle><b>Info</b></AlertTitle>
							Il paziente zero (caso indice) ha ottenuto l'esito del
							tampone <b>{tamponiContext.state.tampone?.esitoTampone}</b> il giorno
							{" " + moment(tamponiContext.state.tampone?.dataPrelievoPrevista).format("DD/MM/YYYY")}
						</Alert>

						{/*INFO DA MOSTRARE AI CONTATTI*/}
						{tipoPaziente !== "pazientezero." &&
							<React.Fragment>
								{
									watch("dataInizioIsolamento") &&
									<Alert severity="warning" style={{borderRadius: 24, margin: 4}}>
										<AlertTitle><b>Info</b></AlertTitle>
										Il paziente zero (caso indice) ha dichiarato nell'intervista di aver iniziato l'isolamento in
										data {moment(watch("dataInizioIsolamento")).format("DD/MM/YYYY")}
									</Alert>
								}
								{
									watch("correttoIsolamento") &&
									<Alert severity="warning" style={{borderRadius: 24, margin: 4}}>
										<AlertTitle><b>Info</b></AlertTitle>
										Il paziente zero (caso indice) ha dichiarato {
										watch("correttoIsolamento") === "true" ? " di mantenere un corretto isolamento " : " di NON garantire un corretto isolamento"
									}
									</Alert>
								}
								{
									watch("dataUltimoContatto") &&
									<Alert severity="warning" style={{borderRadius: 24, margin: 4}}>
										<AlertTitle><b>Info</b></AlertTitle>
										Il paziente zero (caso indice) ha dichiarato nell'intervista che ha avuto l'ultimo contatto con il
										contatto in
										data {moment(watch("dataUltimoContatto")).format("DD/MM/YYYY")}
									</Alert>
								}
							</React.Fragment>
						}

						{/*INFO DA MOSTRARE A PAZ ZERO*/}
						{tipoPaziente === "pazientezero." &&
							<React.Fragment>
								{
									watch("dataInizioIsolamento") &&
									<Alert severity="warning" style={{borderRadius: 24, margin: 4}}>
										<AlertTitle><b>Info</b></AlertTitle>
										Il paziente ha dichiarato nell'intervista di aver iniziato l'isolamento in
										data {moment(watch("dataInizioIsolamento")).format("DD/MM/YYYY")}
									</Alert>
								}
								{
									watch("dataComparsaSintomi") &&
									<Alert severity="warning" style={{borderRadius: 24, margin: 4}}>
										<AlertTitle><b>Info</b></AlertTitle>
										Il paziente ha dichiarato nell'intervista che i sintomi sono comparsi in
										data {moment(watch("dataComparsaSintomi")).format("DD/MM/YYYY")}
									</Alert>
								}
							</React.Fragment>
						}

					</Grid>
					<Grid item xs={12} sm={5}>
						<CustomDateInput
							label={"Data inizio"}
							control={control}
							defaultValue={null}
							rules={{required: true}}
							name={"quarantena.dataInizio"}
							error={errors["quarantena"]?.["dataInizio"]}
						/>
					</Grid>
					<Grid item xs={12} sm={5}>
						<CustomDateInput
							label={"Data fine"}
							control={control}
							defaultValue={null}
							minDate={new Date()}
							rules={{required: true}}
							name={"quarantena.dataFine"}
							error={errors["quarantena"]?.["dataFine"]}
						/>
					</Grid>
					<Grid item xs={12} sm={2}>
						<IconButton
                            onClick={() => {
                                let prevFineDate = watch("quarantena")?.["dataFine"]
                                let newFineDate = removeDays(prevFineDate, 1)
                                setValue("quarantena.dataFine", newFineDate);
                            }}
                            size="large">
							<RemoveTwoToneIcon/>
						</IconButton>
						<IconButton
                            onClick={() => {
                                let prevFineDate = watch("quarantena")?.["dataFine"]
                                let newFineDate = addDays(prevFineDate, 1)
                                setValue("quarantena.dataFine", newFineDate);
                            }}
                            size="large">
							<AddTwoToneIcon/>
						</IconButton>
					</Grid>
					<Grid item xs={12} style={{display: "flex"}}>
						<Typography>Durata
							{"  " + watch("quarantena")?.["tipo"] + ":  "}
							<b style={{color: theme.palette.primary.main, fontSize: 28}}>
								{diffDays(watch("quarantena")?.["dataInizio"], watch("quarantena")?.["dataFine"]) + " "}
								gg</b>
						</Typography>
					</Grid>

					{/*//PRENOTAZIONE TAMPONE*/}
					<Grid item xs={12}>
						<Divider/>
					</Grid>
					<Grid item xs={12}>
						<Typography color={"textSecondary"}>
							Nel caso tu voglia prenotare un tampone al paziente inserisci i dati in modo corretto.
						</Typography>
					</Grid>
					<Grid item xs={12} sm={4}>
						<CustomDateInput
							label={"Data prenotazione"}
							control={control}
							defaultValue={null}
							minDate={new Date()}
							rules={{required: false}}
							name={"tampone.dataRichiesta"}
							error={errors["tampone"]?.["dataRichiesta"]}
						/>
					</Grid>
					<Grid item xs={12} sm={8}>
						<CustomSelect
							control={control}
							rules={{required: false}}
							name={"tampone.luogo"}
							label={"Luogo prenotazione"}
							autoFocus={false}
							none={true}
							defaultValue={""}
							noneValue={""}
							error={errors["tampone"]?.["luogo"]}
						>
							<MenuItem value={"Hotspot"}>
								Hotspot
							</MenuItem>
							<MenuItem value={"Domicilio"}>
								Domicilio
							</MenuItem>
						</CustomSelect>
					</Grid>
					<Grid item xs={12}>
						<CustomMultiText
							inputRef={register({required: false})}
							label={"Note da indicare al gruppo tamponi"}
							autoFocus={false}
							name={"tampone.note"}
							error={errors["tampone"]?.["note"]}
							rows={5}
						/>
					</Grid>
				</Grid>
			</AccordionDetails>
            <AccordionActions>
				<Tooltip title={"Richiedi al gruppo tamponi un tampone per il paziente"}>
					<Button size={"small"} variant={"contained"} disableElevation color={"secondary"}
					        style={{borderRadius: 24}}
					        className={classes.roundButton} disabled={submit} onClick={onPrenotaTampone}>
						<b>Richiedi tampone</b>
					</Button>
				</Tooltip>
				<Tooltip title={"Prosegui con il passo successivo"}>
					<Button size={"small"} color={"primary"} variant={"contained"}
					        disableElevation disabled={submit}
					        className={classes.roundButton}
					        style={{borderRadius: 24}}
					        onClick={handleSubmit(goForward)}>
						<b>Prosegui</b>
					</Button>
				</Tooltip>
			</AccordionActions>
        </React.Fragment>
    );
}

export default React.memo(QuarantenaStep);
